import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { StringUtilityServ } from 'src/app/core/services/utilities/string.service';
import { FormGroup, FormBuilder } from '@angular/forms';
@Component({
  selector: 'app-form-filter',
  templateUrl: './form-filter.component.html',
  styleUrls: ['./form-filter.component.scss']
})
export class FormFilterSucursalComponent implements OnInit {
  @Input('data') public data: any;
  @Input() public options: any;
  @Output() eventForm: EventEmitter<any> = new EventEmitter<any>();
  public catalogAuto: any;
  public form: FormGroup;
  public inputNoValid: boolean;
  constructor(
    private strServ: StringUtilityServ,
    private formB: FormBuilder
  ) {
    this.form = this.formB.group({
      fInput: ['', []],
      fDistance: [10, []],
    });
  }

  ngOnInit() {
    this.initCatalog();
  }

  initCatalog() {
    const catalog = [];
    this.data.forEach(e => {
      if (e.cp !== '' && catalog.find(f => f.type === 'cp' && f.value === e.cp) === undefined) {
        catalog.push({
          type: 'cp',
          value: e.cp,
          label: e.cp + ', ' + e.delegacion + ', ' + e.estado,
          labelt: 'Código Postal',
          lat: e.latitud,
          lon: e.longitud
        });
      }
      if (e.delegacion !== '' && catalog.find(f => f.type === 'ciudad' && f.value === e.delegacion) === undefined) {
        catalog.push({
          type: 'ciudad',
          value: e.delegacion,
          label: e.delegacion + ', ' + e.estado,
          labelt: 'Ciudad',
          lat: e.latitud,
          lon: e.longitud
        });
      }
      if (e.estado !== '' && catalog.find(f => f.type === 'estado' && f.value === e.estado) === undefined) {
        catalog.push({
          type: 'estado',
          value: e.estado,
          label: e.estado,
          labelt: 'Estado',
          lat: e.latitud,
          lon: e.longitud
        });
      }
    });
    this.catalogAuto = catalog;
  }
  searchSuc(option) {
    if (option === 1) {
      this.form.controls.fInput.setValue('');
      if (navigator.geolocation) {
        if (sessionStorage.getItem('location')) {
          let miGPS = JSON.parse(sessionStorage.getItem('location'));
          this.emmitData(miGPS);
        }
        navigator.geolocation.watchPosition((position) => {
          sessionStorage.setItem('location', JSON.stringify({lat: position.coords.latitude, lon: position.coords.longitude}));
          this.emmitData({lat: position.coords.latitude, lon: position.coords.longitude});
        }, err => {
          console.error('Error al obtener ubicación ', err);
        });
      } else {
        alert('Geolocation is not supported by this browser.');
      }
    } else if (option === 2) {
      // console.log('Consultando input: ', this.form.value);
      if (this.form.value.fInput.lat) {
        this.emmitData({lat: Number(this.form.value.fInput.lat), lon: Number(this.form.value.fInput.lon)});
      } else {
        this.inputNoValid = true;
      }
    } else {
      if (this.form.value.fInput.lat) {
        this.emmitData({lat: Number(this.form.value.fInput.lat), lon: Number(this.form.value.fInput.lon)});
      } else if (sessionStorage.getItem('location')) {
        const miGPS = JSON.parse(sessionStorage.getItem('location'));
        this.emmitData(miGPS);
      } else {
        this.inputNoValid = true;
      }
      // this.eventForm.emit({});
    }
  }
  emmitData(data: any = {}) {
    this.inputNoValid = false;
    data.distance = this.form.value.fDistance;
    this.eventForm.emit(data);
  }

  // Autocomplete
  formatter = (x: { label: string }) => {
    this.inputNoValid = false;
    return x ? x.label : '';
  }
  search = (text$: Observable<string>) => {
    if (!text$) { return ; }
    return text$.pipe(
      debounceTime(200),
      map(term => {
        if (term === '') {  return []; }
        const filter = this.catalogAuto.filter(f => {
          return (
            (this.strServ.removeAccents(f.label).toLowerCase().indexOf(term.toLowerCase()) > -1)
          );
        });
        filter.sort((a, b) => {
          return a.priority - b.priority;
        });
        return filter.slice(0, 8);
      })
    );
  }
}
